var _defs, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path2, _path3, _polyline, _polyline2, _polyline3, _polyline4, _polyline5, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _circle, _polyline6, _polygon, _polygon2, _polygon3, _polyline7, _line, _line2, _line3, _line4, _line5, _line6, _line7, _polygon4, _polygon5, _line8, _line9, _line10, _line11, _line12, _line13, _path19, _path20, _line14, _path21, _polyline8, _polyline9, _polyline10, _rect7, _polyline11, _line15, _path22, _path23, _polygon6, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSiaNormsV1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 284 152",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#403e56;}.cls-2{fill:#fff;}.cls-2,.cls-4,.cls-6,.cls-7,.cls-8,.cls-9{stroke:#413e56;}.cls-2,.cls-4{stroke-miterlimit:10;}.cls-3{fill:#4ab382;}.cls-10,.cls-4,.cls-6,.cls-7,.cls-8,.cls-9{fill:none;}.cls-5{fill:#1d1d1b;}.cls-10,.cls-6,.cls-7,.cls-8,.cls-9{stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.cls-7{stroke-dasharray:1 4.98;}.cls-8{stroke-dasharray:0.97 4.87;}.cls-9{stroke-dasharray:1 5.02;}.cls-10{stroke:#1d1d1b;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_sia-norms_v1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106.15,34.13a6.34,6.34,0,0,0-6.34,6.33v73a6.35,6.35,0,0,0,6.34,6.34H159.7a6.35,6.35,0,0,0,6.34-6.34v-73a6.35,6.35,0,0,0-6.34-6.33Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 103.1,
    y: 38.63,
    width: 59.64,
    height: 76.68
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 122.39,
    y: 67.8,
    width: 32.55,
    height: 2.89
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 122.39,
    y: 75.52,
    width: 32.55,
    height: 2.89
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 122.39,
    y: 83.24,
    width: 32.55,
    height: 2.89
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 122.39,
    y: 90.95,
    width: 32.55,
    height: 2.89
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 122.39,
    y: 98.67,
    width: 32.55,
    height: 2.89
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M144,30.43h-5.26V29.35a2.94,2.94,0,0,0-2.94-2.94h-5.69a2.94,2.94,0,0,0-2.94,2.94v1.08h-5.26a2.94,2.94,0,0,0-2.94,2.94h0v8.15h28V33.37A2.94,2.94,0,0,0,144,30.43Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M131,109.73a9.14,9.14,0,0,1,2.79-1.48,2.93,2.93,0,0,1,2.77.5,1.71,1.71,0,0,1,.41,2.15,1.39,1.39,0,0,1-.91.65,1.06,1.06,0,0,1-1-.38,1,1,0,0,1-.25-1,1.3,1.3,0,0,1,.82-.7,6.39,6.39,0,0,1,1.23-.25l1.7-.23,7-1,7.77-1.06a.24.24,0,0,0,.17-.3.26.26,0,0,0-.3-.17l-15.46,2.12c-.56.08-1.13.13-1.68.24a2.83,2.83,0,0,0-1.21.51,1.43,1.43,0,0,0,0,2.23,1.58,1.58,0,0,0,2.29-.17,2.08,2.08,0,0,0,.16-2.55,3.1,3.1,0,0,0-3-1.24,8.17,8.17,0,0,0-3.54,1.65c-.25.18,0,.6.25.42Z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "113.14 100.11 115.21 102.22 119.33 96.36"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "113.14 69.6 115.21 71.71 119.33 65.86"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "113.14 77.23 115.21 79.34 119.33 73.48"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "113.14 84.86 115.21 86.97 119.33 81.11"
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "113.14 92.48 115.21 94.59 119.33 88.73"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M120.61,58.86h-2l-3.2-5.48h0c.07,1,.1,1.66.1,2.08l0,3.42h-1.37l0-7.28h2L119.25,57h0c0-.94-.08-1.61-.08-2l0-3.45h1.38Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M127.36,56a3,3,0,0,1-.7,2.12,2.57,2.57,0,0,1-2,.78,2.74,2.74,0,0,1-1.42-.34,2.3,2.3,0,0,1-1-1,3.38,3.38,0,0,1-.33-1.53,3,3,0,0,1,.69-2.13,2.64,2.64,0,0,1,2-.76,2.7,2.7,0,0,1,1.41.34,2.33,2.33,0,0,1,1,1A3.32,3.32,0,0,1,127.36,56Zm-3.85,0a2.43,2.43,0,0,0,.28,1.25,1.14,1.14,0,0,0,1.76,0,2.45,2.45,0,0,0,.26-1.25,2.34,2.34,0,0,0-.28-1.24,1.14,1.14,0,0,0-1.76,0A2.39,2.39,0,0,0,123.51,56.05Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M131.7,53.12a2.37,2.37,0,0,1,.51.05l-.1,1.42a2,2,0,0,0-.45-.05,1.59,1.59,0,0,0-1.13.38,1.36,1.36,0,0,0-.4,1l0,2.83h-1.52l0-5.56h1.14l.23.93h.08a2.07,2.07,0,0,1,.69-.75A1.75,1.75,0,0,1,131.7,53.12Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M138.24,58.75h-1.52l0-3.25a1.57,1.57,0,0,0-.21-.9.7.7,0,0,0-.63-.3.94.94,0,0,0-.85.43,2.81,2.81,0,0,0-.25,1.41v2.62h-1.51l0-5.56h1.16l.21.71h.08a1.51,1.51,0,0,1,.65-.6,2,2,0,0,1,1-.22,1.73,1.73,0,0,1,1.69.8h.14a1.54,1.54,0,0,1,.65-.61,2.39,2.39,0,0,1,1-.22,2,2,0,0,1,1.44.48,2.13,2.13,0,0,1,.49,1.55l0,3.63h-1.53l0-3.25a1.67,1.67,0,0,0-.2-.9.72.72,0,0,0-.64-.3,1,1,0,0,0-.83.4,2.33,2.33,0,0,0-.27,1.27Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M145.78,58.8a2.83,2.83,0,0,1-2.1-.72,2.79,2.79,0,0,1-.77-2.1,3.11,3.11,0,0,1,.68-2.17,2.49,2.49,0,0,1,1.93-.77,2.4,2.4,0,0,1,1.84.66,2.55,2.55,0,0,1,.67,1.85v.74l-3.58,0a1.47,1.47,0,0,0,.39,1,1.3,1.3,0,0,0,1,.35,3.64,3.64,0,0,0,.95-.11,4.48,4.48,0,0,0,.94-.34V58.4a3.71,3.71,0,0,1-.85.3A5,5,0,0,1,145.78,58.8Zm-.24-4.68a1,1,0,0,0-.76.31,1.43,1.43,0,0,0-.31.87h2.13a1.22,1.22,0,0,0-.29-.87A1,1,0,0,0,145.54,54.12Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M154.42,58.65H152.9l0-3.25a1.57,1.57,0,0,0-.22-.9.78.78,0,0,0-.68-.3,1.05,1.05,0,0,0-.92.43,2.68,2.68,0,0,0-.28,1.42l0,2.61h-1.52l0-5.56h1.16l.21.71h.08a1.6,1.6,0,0,1,.7-.61,2.31,2.31,0,0,1,1-.21,1.9,1.9,0,0,1,1.47.51,2.07,2.07,0,0,1,.51,1.51Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M198.82,106.82l-.48.14"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M193.86,109.07c-2.72,2-4.33,4.92-4.4,9.34C189.14,138.6,170.54,144,154.62,146c-9.42,1.17-13.79-7.21-15.46-11.79"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M138.42,131.82l-.12-.48"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M264.47,73.72l.19.46"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M266.28,78.77c2.35,7.68,2.6,14.6,1.1,19.68-2.7,9.17-13.41,10.52-26.07,9.85"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M238.88,108.15l-.5,0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M52.2,87.42l.38-.32"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M57.21,85.3c8-1.4,22.92-.44,25.16-4.87,12.25-24.15-21.81-26.7-16.25-48.1C75.05-2,157.9,15.11,174.88,17.17q8.3,1,15.76,2.67"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M193.09,20.4l.48.12"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 47.74,
    cy: 93.73,
    r: 4.48
  })), _polyline6 || (_polyline6 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "133 133.19 136.84 127.05 143.91 131.12"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "53.46 70.51 40.49 33.47 45.25 30.32 53.46 70.51"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "39.47 33.42 26.47 70.55 34.69 30.32 39.47 33.42"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "42.12 10.16 42.12 19.01 38.07 19.03 38.07 10.16 42.12 10.16"
  })), _polyline7 || (_polyline7 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-10",
    points: "42.12 19.01 45.27 18.99 45.34 30.2 40.05 33.71 34.75 30.27 34.68 19.05 38.07 19.03"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 48.46,
    y1: 120.77,
    x2: 45.36,
    y2: 123.86
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 42.8,
    y1: 115.11,
    x2: 39.71,
    y2: 118.2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 37.14,
    y1: 109.45,
    x2: 34.05,
    y2: 112.55
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 54.11,
    y1: 126.42,
    x2: 51.02,
    y2: 129.52
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 59.77,
    y1: 132.08,
    x2: 56.68,
    y2: 135.17
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 65.43,
    y1: 137.74,
    x2: 62.33,
    y2: 140.83
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 31.49,
    y1: 103.79,
    x2: 28.39,
    y2: 106.89
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "47.2 110.58 39.51 118.27 22.6 101.36 22.73 101.23 25.83 98.14 30.29 93.67 47.2 110.58"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "69.89 133.27 65.43 137.74 62.33 140.83 62.2 140.96 45.3 124.06 52.99 116.37 69.89 133.27"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 38.67,
    y1: 113.58,
    x2: 36.88,
    y2: 115.37
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 33.01,
    y1: 107.92,
    x2: 31.22,
    y2: 109.72
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 49.99,
    y1: 124.89,
    x2: 48.19,
    y2: 126.69
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 55.64,
    y1: 130.55,
    x2: 53.85,
    y2: 132.34
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 61.3,
    y1: 136.21,
    x2: 59.5,
    y2: 138
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 27.36,
    y1: 102.27,
    x2: 25.56,
    y2: 104.06
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M69.4,100,53,116.37,32.33,137c-.26-3.69-2.28-5.53-5.79-5.8l13-13,7.69-7.69L63.61,94.16Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M32.33,137l-7.85,2.05,2.06-7.85C30.05,131.5,32.07,133.34,32.33,137Z"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 60.04,
    y1: 97.83,
    x2: 65.74,
    y2: 103.48
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M267,64.87A5.93,5.93,0,0,1,261,70.79H200.84v-53h54.22A6.09,6.09,0,0,1,261,11.63,6,6,0,0,1,267,17.58V64.87a6,6,0,1,0-11.91,0V17.75"
  })), _polyline8 || (_polyline8 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-10",
    points: "236.37 31.26 243.47 31.26 243.47 55.47 237.95 55.47 232.41 55.47 225.64 55.47"
  })), _polyline9 || (_polyline9 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-10",
    points: "225.47 55.47 225.64 55.47 225.64 55.48 209.44 55.48 209.44 27.76 225.64 27.76 225.64 31.26 231.55 31.26"
  })), _polyline10 || (_polyline10 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-10",
    points: "225.47 44.4 225.47 55.47 225.47 62.51 240.95 62.51 240.95 55.62"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 243.55,
    y: 33.91,
    width: 4.68,
    height: 8.14
  })), _polyline11 || (_polyline11 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-10",
    points: "224.82 47.24 217.9 47.24 217.9 55.08"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 209.45,
    y1: 39.3,
    x2: 225.44,
    y2: 39.3
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M236.71,132.06l-6.32-1.88-2.08,6.08c-2.86-5.38-4.74-9.26-6-12-2.42-5.28-2.46-6.21-2.73-5.16l-2.72,5.37-6,11.78-2.09-6.08-6.32,1.88,10-19a4.48,4.48,0,0,1,1.39,2.63c.12.73.38,1.26.87,1.41s1-.16,1.5-.72a4.5,4.5,0,0,1,6.77,0c.49.56,1,.86,1.49.72s.76-.68.87-1.41a4.51,4.51,0,0,1,1.4-2.64Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M235.84,101.53a4.47,4.47,0,0,1-1-6.69c.48-.57.71-1.12.5-1.59s-.78-.65-1.52-.66a4.48,4.48,0,0,1-4.43-5.11c.09-.74,0-1.32-.44-1.6s-1-.13-1.64.26a4.48,4.48,0,0,1-6.49-1.9c-.32-.68-.73-1.11-1.24-1.11s-.91.43-1.23,1.11a4.48,4.48,0,0,1-6.49,1.9c-.64-.39-1.21-.54-1.64-.26s-.54.86-.44,1.6a4.49,4.49,0,0,1-4.43,5.11c-.75,0-1.31.2-1.52.66s0,1,.49,1.59a4.48,4.48,0,0,1-1,6.69c-.62.42-1,.88-.92,1.38s.56.85,1.27,1.07a4.48,4.48,0,0,1,2.81,6.15c-.3.69-.36,1.27,0,1.66s.93.41,1.65.21a4.5,4.5,0,0,1,5.69,3.66c.12.73.38,1.26.87,1.41s1-.16,1.5-.72a4.5,4.5,0,0,1,6.77,0c.49.56,1,.86,1.49.72s.76-.68.87-1.41a4.51,4.51,0,0,1,5.7-3.66c.72.2,1.31.18,1.64-.21s.27-1,0-1.66a4.49,4.49,0,0,1,2.81-6.15c.72-.22,1.2-.56,1.27-1.07S236.46,102,235.84,101.53Zm-7.57,1.81h-5.43v5.43h-6.46v-5.43H211V96.89h5.42V91.46h6.46v5.43h5.43Z"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "228.27 96.89 228.27 103.34 222.84 103.34 222.84 108.77 216.38 108.77 216.38 103.34 210.96 103.34 210.96 96.89 216.38 96.89 216.38 91.46 222.84 91.46 222.84 96.89 228.27 96.89"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flag"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "228.27 96.89 228.27 103.34 222.84 103.34 222.84 108.77 216.38 108.77 216.38 103.34 210.96 103.34 210.96 96.89 216.38 96.89 216.38 91.46 222.84 91.46 222.84 96.89 228.27 96.89"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSiaNormsV1);
export default __webpack_public_path__ + "static/media/icon_sia-norms_v1.398176b5021403446e90de63d8acb0e5.svg";
export { ForwardRef as ReactComponent };